export const CHANGE_STEP = 'scenes/ClientDetail/components/AddVehicleModal/change_step'
export const UPDATE_ID = 'scenes/ClientDetail/components/AddVehicleModal/update_id'
export const UPDATE_DATASET_VALUE = 'scenes/ClientDetail/components/AddVehicleModal/update_dataset_value'

export const VEHICLE_DATASET = 'scenes/ClientDetail/components/AddVehicleModal/vehicle_dataset'
export const DOCUMENTS_DATASET = 'scenes/ClientDetail/components/AddVehicleModal/documents_dataset'

export const RESET_STATE = 'scenes/ClientDetail/components/AddVehicleModal/reset_state'



// WEBPACK FOOTER //
// ./src/scenes/ClientDetail/components/AddVehicleModal/constants.js